import { loadConnectAndInitialize } from '@stripe/connect-js';

class Stripe {

  /* beautify ignore:start */
  #accountSession = null;
  #instance = null;
  /* beautify ignore:end */

  constructor(application) {

    this.application = application;

  }

  async getClientSecret() {

    this.#accountSession = await this.application.serverInterface.startup.createAccountSession();

    return this.#accountSession.clientSecret;

  }

  initializeInstance() {

    const theme = this.application.getCurrentStartup().theme;

    return loadConnectAndInitialize({
      publishableKey: import.meta.env.REACT_APP_STRIPE_KEY,
      fetchClientSecret: async () => {
        return this.getClientSecret();
      },
      fonts: [{
        src: `url(${import.meta.env.REACT_APP_ASSETS_URL}/assets/fonts/external/${theme.fontFamily}/${theme.fontFamily}-Regular.woff)`,
        family: theme.fontFamily
      }],
      appearance: {
        // See all possible variables below
        overlays: 'dialog',
        variables: {
          fontFamily: theme.fontFamily,
          colorPrimary: theme.colors.primary,
          colorBackground: theme.colors.background,
          colorText: theme.colors.text,
          colorDanger: '#F05454',
          borderRadius: '5px',
          buttonPrimaryColorBackground: theme.colors.primary,
          buttonSecondaryColorBackground: theme.colors.secondary,
          buttonPrimaryColorBorder: 'hsla(120, 50%, 50%, 0)',
          buttonPrimaryColorText: '#FFFFFF',
          colorSecondaryText: theme.colors.tertiary,
          colorBorder: '#f4f4f4',
          headingXlFontSize: '25px',
          headingLgFontSize: '20px',
          headingMdFontSize: '18px',
          headingSmFontSize: '16px',
          headingSmFontWeight: '400',
          headingXsFontSize: '15px',
          headingXsFontWeight: '500',
          labelMdFontSize: '16px',
          labelSmFontSize: '16px'
        },
      }
    });

  }

  getInstance() {

    this.#instance = this.initializeInstance();

    return this.#instance;

  }

  async initialize() {

    return this.getInstance();

  }

}

export default Stripe;